/* Danachi 2026 - header glass.
   Feeds the cursor position to the header as --hx/--hy so the specular
   highlight tracks it across the slab. Pure decoration: no-ops on touch and
   for reduced motion, and never touches layout. */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fine.matches || reduced.matches) return;

  var slabs = [];
  function collect() {
    slabs = Array.prototype.slice.call(document.querySelectorAll('.header-wrapper'));
  }

  var raf = 0;
  var px = 0;
  var py = 0;

  function apply() {
    raf = 0;
    for (var i = 0; i < slabs.length; i++) {
      var el = slabs[i];
      var r = el.getBoundingClientRect();
      if (!r.height || !r.width) continue;
      /* let the highlight run a little past the edges so it eases off screen
         rather than clamping against the header border */
      var x = ((px - r.left) / r.width) * 100;
      var y = ((py - r.top) / r.height) * 100;
      el.style.setProperty('--hx', Math.max(-40, Math.min(140, x)).toFixed(1) + '%');
      el.style.setProperty('--hy', Math.max(-120, Math.min(220, y)).toFixed(1) + '%');
    }
  }

  window.addEventListener('pointermove', function (e) {
    px = e.clientX;
    py = e.clientY;
    if (!raf) raf = requestAnimationFrame(apply);
  }, { passive: true });

  if (document.readyState !== 'loading') collect();
  else document.addEventListener('DOMContentLoaded', collect);

  /* the theme editor re-renders the header group */
  document.addEventListener('shopify:section:load', collect);
})();
